import React, { useState } from "react";
import { Box, Text } from "reusable";

export interface AdData {
  imageUrl: string;
  linkUrl?: string;
  altText?: string;
  title?: string; // Optional title for the ad
}

const AdTile = ({ ad }: { ad: AdData }): JSX.Element => {
  const [isImageReady, setIsImageReady] = useState(false);
  const [hasImageError, setHasImageError] = useState(false);

  return (
    <Box
      className="profile-summary ad-tile"
      role="complementary"
      ariaLabel="Advertisement"
      onClick={() => {
        if (ad.linkUrl) {
          window.open(ad.linkUrl, "_blank");
        }
      }}
    >
      <Box className="ad-tile-image">
        <img 
          src={ad.imageUrl}
          alt={ad.altText || "Advertisement"}
          loading="lazy"
          width="399"
          height="338"
          style={{ opacity: isImageReady ? 1 : 0 }}
          onLoad={() => setIsImageReady(true)}
          onError={() => {
            setHasImageError(true);
            setIsImageReady(true);
          }}
        />
        {hasImageError && (
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            height="100%"
            width="100%"
            style={{ position: "absolute", inset: 0 }}
          >
            <Text>Advertisement</Text>
          </Box>
        )}
        <Box className="ad-badge">
          <Text>AD</Text>
        </Box>
      </Box>
      
    </Box>
  );
};

export default AdTile;